import { useLayoutEffect, useRef } from "react";

/**
 * Hook to restore scroll position for a component wrapped in <Activity>.
 * Leverages React 19's <Activity> lifecycle where useLayoutEffect setup/cleanup
 * runs when the component becomes visible/hidden.
 */
export function useActivityScrollRestoration(selector = "main") {
  const scrollPosRef = useRef(0);

  useLayoutEffect(() => {
    const el = document.querySelector(selector);
    if (!el) return;

    // Restore scroll position when component becomes visible
    el.scrollTop = scrollPosRef.current;

    return () => {
      // Save scroll position before component becomes hidden
      // (React 19 Activity triggers this cleanup before the display change resets scroll)
      scrollPosRef.current = el.scrollTop;
    };
  }, [selector]);
}
